import { _ as _asyncToGenerator, r as regenerator } from '../../index-6bb2031f.js';
import { _ as _slicedToArray } from '../../slicedToArray-26803f33.js';
import { _ as _defineProperty } from '../../defineProperty-18999f8e.js';
import { t as tinycolor } from '../../tinycolor-c9a47691.js';
import { FLOAT_INT_REGEXP, SVG_COMMAND_REG_EXP, FLOAT_INT_PAIR_REGEXP } from '../../configs/index.js';
import { v as v4 } from '../../v4-c5e36445.js';
import '../../typeof-92b42de1.js';
import '../../unsupportedIterableToArray-577176bf.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getPathAttr = function getPathAttr(path, attr) {
  var value = path.getAttribute(attr);

  if (value) {
    return value;
  }

  if (!path.parentElement) {
    return;
  }

  return getPathAttr(path.parentElement, attr);
};

var getPathFill = function getPathFill(path) {
  var _path$style;

  var val = getPathAttr(path, 'fill');

  if (!val && (_path$style = path.style) !== null && _path$style !== void 0 && _path$style.fill && path.style.fill.includes('rgb')) {
    return tinycolor(path.style.fill).toHex8String();
  }

  return val;
};

var getAttributesFromSVG = function getAttributesFromSVG(path) {
  return {
    path: path.getAttribute('d') || '',
    stroke: getPathAttr(path, 'stroke'),
    opacity: Number(getPathAttr(path, 'fill-opacity')) || 0,
    strokeWidth: Number(getPathAttr(path, 'stroke-width')) || 0,
    lineCap: getPathAttr(path, 'stroke-linecap'),
    lineJoin: getPathAttr(path, 'stroke-linejoin'),
    fill: getPathFill(path) === 'none' ? '' : getPathFill(path),
    id: v4()
  };
};

function standardReplace() {
  var count = 0;
  return function (match, width, height) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var _options$moveX = options.moveX,
        moveX = _options$moveX === void 0 ? 0 : _options$moveX,
        _options$moveY = options.moveY,
        moveY = _options$moveY === void 0 ? 0 : _options$moveY;
    count++;
    var widthOrHeight = count % 2 ? width : height;
    var moveXorY = count % 2 ? moveX : moveY;
    return (parseFloat(match) * widthOrHeight + moveXorY).toString();
  };
}

function convertSvgToRange(_ref) {
  var paths = _ref.paths,
      width = _ref.width,
      height = _ref.height;

  if (width === 0 || height === 0) {
    throw new Error('width or height is zero');
  }

  return paths.map(function (path) {
    var attributes = getAttributesFromSVG(path);
    return _objectSpread(_objectSpread({}, attributes), {}, {
      path: attributes.path.replace(SVG_COMMAND_REG_EXP, function (match) {
        return replacer(match, width, height);
      })
    });
  });
}

function replacer(match, width, height) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var _match = _slicedToArray(match, 1),
      command = _match[0];

  var _options$moveX2 = options.moveX,
      moveX = _options$moveX2 === void 0 ? 0 : _options$moveX2,
      _options$moveY2 = options.moveY,
      moveY = _options$moveY2 === void 0 ? 0 : _options$moveY2;

  switch (command) {
    case 'H':
      return match.replace(FLOAT_INT_REGEXP, function (subMatch) {
        return (parseFloat(subMatch) * width + moveX).toString();
      });

    case 'h':
      return match.replace(FLOAT_INT_REGEXP, function (subMatch) {
        return (parseFloat(subMatch) * width).toString();
      });

    case 'V':
      return match.replace(FLOAT_INT_REGEXP, function (subMatch) {
        return (parseFloat(subMatch) * height + moveY).toString();
      });

    case 'v':
      return match.replace(FLOAT_INT_REGEXP, function (subMatch) {
        return (parseFloat(subMatch) * height).toString();
      });

    case 'm':
    case 'l':
    case 'c':
    case 's':
    case 't':
    case 'q':
      {
        var _replacerFunc = standardReplace();

        return match.replace(FLOAT_INT_REGEXP, function (subMatch) {
          return _replacerFunc(subMatch, width, height);
        });
      }

    case 'L':
    case 'Q':
    case 'M':
    case 'C':
    case 'S':
    case 'T':
    case 'A':
    case 'a':
      var replacerFunc = standardReplace();
      return match.replace(FLOAT_INT_REGEXP, function (subMatch) {
        return replacerFunc(subMatch, width, height, options);
      });

    case 'Z':
    case 'z':
      return match;

    default:
      throw new Error("".concat(command, " command is not supported"));
  }
}
function loadSvgForLayer(_x) {
  return _loadSvgForLayer.apply(this, arguments);
} // For grids

function _loadSvgForLayer() {
  _loadSvgForLayer = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(url) {
    var response, blobSvg, data;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(url);

          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.blob();

          case 5:
            blobSvg = _context.sent;
            _context.next = 8;
            return new Promise(function (resolve) {
              var object = document.createElement('object');
              object.type = 'image/svg+xml';
              object.title = 'fake';
              object.addEventListener('load', function () {
                var doc = object.contentDocument;
                var paths = Array.from((doc === null || doc === void 0 ? void 0 : doc.querySelectorAll('path')) || []);
                var svgTag = doc === null || doc === void 0 ? void 0 : doc.querySelector('svg');
                var svgParams = svgTag === null || svgTag === void 0 ? void 0 : svgTag.getBBox();
                var width = Number(svgTag === null || svgTag === void 0 ? void 0 : svgTag.getAttribute('width')) || (svgParams === null || svgParams === void 0 ? void 0 : svgParams.width) || 0;
                var height = Number(svgTag === null || svgTag === void 0 ? void 0 : svgTag.getAttribute('height')) || (svgParams === null || svgParams === void 0 ? void 0 : svgParams.height) || 0;
                var pathsFrom0To1 = convertSvgToRange({
                  paths: paths,
                  width: 1 / ((svgParams === null || svgParams === void 0 ? void 0 : svgParams.width) || 1),
                  height: 1 / ((svgParams === null || svgParams === void 0 ? void 0 : svgParams.height) || 1)
                });
                document.body.removeChild(object);
                resolve({
                  width: width,
                  height: height,
                  paths: pathsFrom0To1
                });
              }, false);
              object.data = URL.createObjectURL(blobSvg);
              object.classList.add('visually-hidden');
              document.body.append(object);
            });

          case 8:
            data = _context.sent;
            return _context.abrupt("return", data);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadSvgForLayer.apply(this, arguments);
}

var convertCoordsToSvgPath = function convertCoordsToSvgPath(str) {
  var isFirst = true;
  var matchedStr = str.replace(FLOAT_INT_PAIR_REGEXP, function (match) {
    var result = "".concat(isFirst ? 'M' : 'L', " ").concat(match);
    isFirst = false;
    return result;
  });
  return "".concat(matchedStr, "Z");
};

export { convertCoordsToSvgPath, loadSvgForLayer, replacer };
